import _ from 'lodash';
import { createSelector } from 'reselect';

import { StoreState } from '../../../redux/reducers/store.types';

import { OperationGroupsState } from './operation-groups.reducer';
import { OperationGroup } from './operation-groups.types';

export const getOperationGroupsState = (
  state: StoreState,
): OperationGroupsState => state.operationPanel.operationGroups;

export const getOperationGroupsList = createSelector(
  getOperationGroupsState,
  (state: OperationGroupsState): OperationGroup[] =>
    _.map(state.groupsOrderList, (id) => state.groupsMap[id]),
);
